import { ReactElement, useEffect } from "react";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { CommunityNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { HubDataSource } from "client/Api/Hub/hub";
import { getHubUrlForCommunity } from "client/Features/Hub/Communities/CommunitiesPage";

export type CommunityActivityInvocationProps = {
	data: CommunityNotificationDataViewModel;
	onDismiss: () => void;
};

export const CommunityActivityInvocation = (
	props: CommunityActivityInvocationProps
): ReactElement | null => {
	const { data, onDismiss } = props;
	const { communityId } = data;

	useEffect(
		() => {
			const url: string = getHubUrlForCommunity({
				source: HubDataSource.Community,
				communityId
			});

			navigateTo(url);
			onDismiss();
		},
		[communityId, onDismiss]
	);

	return null;
};

CommunityActivityInvocation.displayName = "CommunityActivityInvocation";
